export const listInput = (value: string) => {
  if (value.length) {
    return value.split(" ")[0];
  } else {
    return "";
  }
};
